/*
 * Copyright (c) 2019. Willker Gomes
 */

import styled from 'styled-components';

import { FaTrashAlt, FaBan, FaRegCheckCircle } from 'react-icons/fa';

export const Container = styled.div``;

export const ModalContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h2 {
    color: #707070;
    padding-bottom: 10px;
  }

  span {
    font-size: 18px !important;
  }

  div {
    display: flex;
    flex: 1;
    width: 100%;
    padding-top: 25px;
    justify-content: center;
  }
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;

  @media (max-width: 450px) {
    flex-direction: column;
  }

  span {
    font-size: 16px;
    color: #707070;
  }
`;

export const ButtonContainer = styled.div`
  padding: 2% 0px;
  display: flex;
  justify-content: flex-end;
  border-width: 0px;
  border-bottom-width: 1px;
  border-color: #c9c7c7;
  border-style: solid;
`;

export const SearchButton = styled.button`
  padding: 12px 30px;
  border-radius: 4px;
  border-color: #b1aeae;
  border-width: 1px;
  margin: 0px 5px;
  font-size: 16px;
  background: #fff;
  box-shadow: 0 1px 3px rgb(0, 0, 0, 0.16);
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};

  @media (max-width: 450px) {
    font-size: 12px;
    padding: 6px 15px;
  }
`;

export const AddButton = styled(SearchButton).attrs({
  type: 'button',
})`
  background-color: #eaeaea;
`;

export const CancelButton = styled(SearchButton)`
  margin-right: 5px;
`;
export const DeleteButton = styled(AddButton)``;

export const ResultsTable = styled.table`
  border-collapse: collapse;
  margin: 5px 0px;

  tr {
    th {
      box-shadow: 0 1px 6px rgb(0, 0, 0, 0.16);
      background: white;
      width: 100%;
      color: #979797;
      font-weight: normal;
      font-size: 16px;
      text-align: start;
      padding: 15px 22px;

      @media (max-width: 450px) {
        font-size: 14px;
        padding: 6px 15px;
      }
    }
    th:first-child {
      border-right: 1px solid #cccccc;
    }

    td {
      :first-child {
        padding: 15px 22px;
        @media (max-width: 450px) {
          padding: 6px 15px;
        }
      }
      padding: 10px;
      text-align: start;
      border-bottom: 1px solid #cccccc;
      border-right: 1px solid #cccccc;
      color: #979797;
      font-size: 15px;
      @media (max-width: 450px) {
        padding: 6px;
        font-size: 13px;
      }
    }

    td:last-child {
      border-right: 0px;
    }
  }
`;

export const CheckCircleIcon = styled(FaRegCheckCircle)`
  color: green;
  width: 26px;
  height: 26px;

  &:hover {
    opacity: 0.5;
  }
`;

export const BanIcon = styled(FaBan)`
  color: red;
  width: 26px;
  height: 26px;

  &:hover {
    opacity: 0.5;
  }
`;

export const DeleteIcon = styled(FaTrashAlt)`
  color: #707070;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  width: 26px;
  height: 26px;
  opacity: ${props => (props.disabled ? 0.5 : 1)};

  &:hover {
    opacity: 0.5;
  }
`;

export const TableCellContent = styled.div`
  display: flex;
`;

export const TableCellValue = styled.div`
  flex: 1;
  width: 1px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
`;
